<template>
  <div class="hello">
    <div @click="visible = !visible" class="organizationheader">
      <b>{{campName}}</b>
      ({{allSessions.length}})
    </div>
    <div v-if="visible">
      <div v-for="(sessions, campname) in dedupedSessions" v-bind:key="campname">
        {{campname}}
        <a target="_new" :href="sessions[0].url">
          <img style="width:1em;vertical-align:middle" src="../assets/externallink.png" />
        </a>
        <template v-if="dedupedLocations(sessions).size > 1">
          (<span
            v-for="(location, index) in dedupedLocations(sessions)"
            :key="location"
          >{{index!=0 ? ", " :""}}{{location}}</span>)
        </template>
        <br />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  fiery: true, // required to add this.$fiery to this component
  name: "SessionList",
  components: {},
  props: {
    campName: String,
    allSessions: Array
  },
  computed: {
    dedupedSessions() {
      var deduped = {};
      this.allSessions.forEach(session => {
        if (!deduped[session.camp_name]) deduped[session.camp_name] = [];
        deduped[session.camp_name].push(session);
      });
      return deduped;
    }
  },
  methods: {
    dedupedLocations(sessions) {
      var locations = new Set();
      sessions.forEach(session => {
        locations.add(session.location);
      });
      
      return locations;
    }
  },
  data() {
    return { visible: false };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div {
  background-color: rgb(219, 216, 212);
  text-align: left;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #436153;
}
.organizationheader {
  border-top: 1px solid grey;
}
</style>
